<ls-overline>
  <ng-container *ngFor="let link of links; let last = last">
    <a *ngIf="link.path != null" href="{{ link.path }}">{{ link.label | spaceCapCase }}</a>
    <span *ngIf="link.path == null">{{ link.label | spaceCapCase }}</span>
    <span *ngIf="!last"> / </span>
  </ng-container>
</ls-overline>
